import template from 'lodash/template';
import { ajaxSend } from '../../../api/api';
const getPath = template('/v2/queues/${queueId}/agents');
export function getQueueAgents(queueId, params = {}) {
    return ajaxSend({
        path: getPath({ queueId }),
        params: params,
    });
}
export function addAgentsToQueue(queueId, agentIds) {
    const deconstAgentIds = agentIds.map((id) => {
        return {
            agent_id: id,
        };
    });
    return ajaxSend({
        path: getPath({ queueId }),
        method: 'PUT',
        data: { agents: deconstAgentIds },
    });
}
export function updateQueueAgents(queueId, agents) {
    return ajaxSend({
        path: getPath({ queueId }),
        method: 'PUT',
        data: {
            agents,
        },
    });
}
export function removeQueueAgents(queueId, agents) {
    return ajaxSend({
        method: 'DELETE',
        path: `${getPath({ queueId })}`,
        data: { agents },
    });
}
